import { useMemo } from 'react';

import { useStoreContext } from './useStoreContext';

export const isReadOnly = (roles: string[]): boolean => {
  if (!Array.isArray(roles)) return false;
  return (
    roles.includes('shipping_view') &&
    !roles.includes('nuvem_envio') &&
    !roles.includes('full')
  );
};

const useIsReadOnly = (): boolean => {
  const { roles } = useStoreContext();
  return useMemo(() => isReadOnly(roles), [roles]);
};

export default useIsReadOnly;
